import { types } from '@jbrowse/mobx-state-tree';
export const NoAssemblyRegion = types
    .model('NoAssemblyRegion', {
    refName: types.string,
    start: types.number,
    end: types.number,
    reversed: types.optional(types.boolean, false),
})
    .actions(self => ({
    setRefName(newRefName) {
        self.refName = newRefName;
    },
}));
export const Region = types.compose('Region', NoAssemblyRegion, types.model({
    assemblyName: types.string,
}));
export const LocalPathLocation = types.model('LocalPathLocation', {
    locationType: types.literal('LocalPathLocation'),
    localPath: types.string,
});
export const BlobLocation = types.model('BlobLocation', {
    locationType: types.literal('BlobLocation'),
    name: types.string,
    blobId: types.string,
});
export const FileHandleLocation = types.model('FileHandleLocation', {
    locationType: types.literal('FileHandleLocation'),
    name: types.string,
    handleId: types.string,
});
export const UriLocationRaw = types.model('UriLocation', {
    locationType: types.literal('UriLocation'),
    uri: types.string,
    baseUri: types.maybe(types.string),
    internetAccountId: types.maybe(types.string),
    internetAccountPreAuthorization: types.maybe(types.model('InternetAccountPreAuthorization', {
        internetAccountType: types.string,
        authInfo: types.frozen(),
    })),
});
export const UriLocation = types.snapshotProcessor(UriLocationRaw, {
    postProcessor: snap => {
        const { baseUri, ...rest } = snap;
        if (!baseUri) {
            return rest;
        }
        return snap;
    },
});
export const FileLocation = types.snapshotProcessor(types.union(LocalPathLocation, UriLocation, BlobLocation, FileHandleLocation), {
    preProcessor(snap) {
        if (!snap) {
            return undefined;
        }
        const { locationType, ...rest } = snap;
        if (!locationType) {
            const { uri, localPath, blob, handleId } = rest;
            let locationType = '';
            if (uri !== undefined) {
                locationType = 'UriLocation';
            }
            else if (localPath !== undefined) {
                locationType = 'LocalPathLocation';
            }
            else if (blob !== undefined) {
                locationType = 'BlobLocation';
            }
            else if (handleId !== undefined) {
                locationType = 'FileHandleLocation';
            }
            return { ...rest, locationType };
        }
        return snap;
    },
});
export { ElementId, createElementId } from "./ElementId.js";
